function DDUMainWipers({value}) {
    return (
        <div className={`${value["wiper-stage"] !== 0 ? "bg-[#0bda5b80]" : "bg-[#137fec33]"} flex items-center justify-center w-full h-full`}>
            <svg
                className="w-[28px]"
                viewBox="0 0 95.949 73.214"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(-168.2 -300.02)">
                <g 
                    fill="none" 
                    stroke={value["wiper-stage"] !== 0 ? "#0bda5a" : "#838383"}
                    strokeLinecap="round" 
                    strokeWidth="5"
                >
                    <path 
                    d="m57.321 131.96c15.312-20.881 18.25-24.243 18.25-24.243l4.9641-6.2924c4.699-5.957-23.418-13.751-39.821-13.751-16.402 0-45.772 7.462-39.821 14.821l25 29.29z" 
                    transform="translate(175.59 219.84)" 
                    />
                    <path 
                    d="m41.964 142.95c0 2.219-1.7989 4.0178-4.0179 4.0178s-4.0179-1.7988-4.0179-4.0178 1.7989-4.0179 4.0179-4.0179 4.0179 1.7989 4.0179 4.0179z" 
                    transform="translate(179.16 218.77)" 
                    style={{ color: '#000' }} 
                    />
                    <path 
                    d="m41.518 141.88-19.584-52.027" 
                    transform="translate(175.59 219.84)" 
                    />
                </g>
                </g>
            </svg>
        </div>
    );
}

export default DDUMainWipers;